import { createAction } from 'redux-actions';

export const LOADING_START = 'LOADING::START';
export const LOADING_END = 'LOADING::END';

export const startLoading = createAction(LOADING_START);
export const endLoading = createAction(LOADING_END);
